import { SvgIcon } from '@mui/material';

export default function HomeIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 18 18" style={{ ...props.style }}>
      <g>
        <g id="uuid-5a55c403-35a8-4246-81ed-91d3ab1b8c17">
          <path
            strokeWidth="0px"
            d="m0.28814,8.13487l8.75,-7.66l8.75,7.66l0,10.94l-5.47,0l0,-4.37c0,-1.81 -1.47,-3.28 -3.28,-3.28c-1.81,0 -3.28,1.47 -3.28,3.28l0,4.37l-5.47,0l0,-10.94z"
            className="uuid-56450b7e-e699-4859-bbc9-b53565591ee8"
            id="uuid-a60fde95-94f2-40ff-925f-36020b32305f"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
